/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { SET_CONTACT_US_DOMAIN } from 'store/actions/types';
import { RootState } from 'store/reducers';
import errorMessages from 'utils/errorMessages';
import faqIMG from '../assets/img/faq.png';
import * as auth from '../store/actions/auth.action';
import { getLocalStorageValue, handleToast, isValidDomainName, isValidEmail, localStorageKeyValue } from '../utils/handler';
import { BaseResponse } from './types/agentDetailsQuestions';
import { CreateCloseLead } from './types/lead.types';

export const ContactUs: React.FC = (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const [email, setEmail] = useState(getLocalStorageValue(localStorageKeyValue.userEmail));
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);
  const [comments, setComments] = useState('');
  const [name, setName] = useState('');
  const [domainName, setDomainName] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneValidationError, setPhoneValidationError] = useState('');
  const [loadingBTN, setLoadingBTN] = useState(false);
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const { contactUsDomainName } = useSelector((state: RootState) => state.leadReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    // const query = new URLSearchParams(history.location.search);
    // const email: string | null = query.get('email') || localStorage.getItem(localStorageKeyValue.userEmail);
    // if (email) {
    //     history.replace({
    //         search: ""
    //     })
    //     setEmail(email || "")
    // }
  }, []);
  useEffect(() => {
    // console.log('contactUsDomainName', contactUsDomainName);
    if (contactUsDomainName) {
      setDomainName(contactUsDomainName);
      dispatch({ type: SET_CONTACT_US_DOMAIN, payload: '' });
    }
    // return () => {

    // }
  }, [contactUsDomainName]);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    setLoadingBTN(true);
    if (isValid()) {
      let payload: CreateCloseLead = {
        email,
        comments,
        name,
        phone,
        domainName,
        budget: '',
      };
      auth.createCloseContactUsLead(payload).then((res: BaseResponse) => {
        if (res) {
          setEmail('');
          setName('');
          setComments('');
          setPhone('');
          setDomainName('');
          toast.success('Form Submitted, One of our agents will get back to you within one business day or less.');
          history.goBack();
        }
        setFormSubmitted(false);
        setLoadingBTN(false);
      });
    } else {
      setLoadingBTN(false);
    }
  };
  const isValid = () => {
    if (!email) {
      return false;
    } else if (isValidEmail(email)) {
      return false;
    } else if (name === '') {
      return false;
    } else if (comments === '') {
      return false;
    } else if (phoneValidationError || !isValidPhoneNumber(phone) || !phone) {
      return false;
    } else if (domainName === '' || !domainName) {
      return false;
    } else if (!isValidDomainName(domainName)) {
      handleToast({ message: errorMessages.domainWithoutExtension });
      return false;
    }
    return true;
  };
  // } else if (phoneValidationError || !isValidPhoneNumber(contactUsForm.phone) || !contactUsForm.phone) {
  //     return false;
  //   } else if (!isValidDomainName(contactUsForm.domainName)) {
  //     handleToast({message: errorMessages.domainWithoutExtension});
  //     return false;
  //   }
  //   return true;
  // };
  const phoneNumberChange = (value: any) => {
    if (!value || (value && isValidPhoneNumber(value))) {
      setPhoneValidationError('');
    }
    if (isFormSubmitted && value && !isValidPhoneNumber(value)) {
      setPhoneValidationError('Invalid phone number');
    }
    setPhone(value);
  };
  return (
    <div className="content-body">
      <Helmet>
        <title>Contact Us - Saw.com Domain Name Brokerage</title>
      </Helmet>
      <div className="ash-bg overflow-hide">
        <div className="container text-center justify-content-center  ">
          <img alt="" className="header-db-img-center" src={faqIMG}></img>
          <div className="main-text"> {t('Contact Us')}</div>
        </div>
      </div>
      <div className="container card appraisal-result-body card-shadow mt--40">
        <div className="container ">
          <div className="row justify-content-center">
            <form noValidate className={'col-lg-10 row mt-3 px-2 '} onSubmit={submit}>
              <div className="form-group col-lg-6 col-md-12 ">
                <input
                  autoComplete="off"
                  type="text"
                  className={'form-control saw-input ' + (isFormSubmitted && name === '' ? 'is-invalid ' : '')}
                  name="name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  placeholder={t('Enter your Name')}
                  required
                />
                <div className="invalid-feedback">{t('Please Enter Name')}</div>
              </div>
              <div className="form-group  col-lg-6 col-md-12 ">
                <input
                  autoComplete="off"
                  type="text"
                  className={'form-control saw-input ' + (isFormSubmitted && (isValidEmail(email) || !email) ? ' is-invalid' : '')}
                  name="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  placeholder={t('Enter your Email')}
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                  required
                />
                <div className="invalid-feedback">{t('Please Enter Valid Email')}</div>
              </div>
              <div className="form-group col-lg-6 col-md-12 ">
                <PhoneInput international defaultCountry={localCountryStr} placeholder="Phone Number*" value={phone || undefined} onChange={(data) => phoneNumberChange(data || '')} className="form-control" />
                <div className="invalid-feedback error-message  ">{t('Please Enter Phone Number')}</div>

                {isFormSubmitted && !phone && <div className="text-danger error-message">{t('Please Enter Valid Phone Number')}</div>}
                {isFormSubmitted && phone && !isValidPhoneNumber(phone) ? <div className="text-danger error-message">{t('Invalid phone number')}</div> : null}
              </div>
              <div className="form-group col-lg-6 col-md-12 ">
                <input autoComplete="off" type="text" className={'form-control saw-input ' + (isFormSubmitted && (!isValidDomainName(domainName) || !domainName) ? ' is-invalid' : '')} value={domainName} name="domainName" onChange={(e) => setDomainName(e.target.value)} placeholder={t('Domain Name*')} title="" required />
                {isFormSubmitted && !domainName && <div className="text-danger error-message">{t('Please Enter Valid Domain Name')}</div>}
                {/* <div className="invalid-feedback">{t('Please Enter Valid Domain Name')}</div> */}
              </div>
              {/* <div className="form-group">
                                <label className="mt-2  ">{t("Name")} *</label>
                                <input autoComplete="off" type="text" className={"form-control saw-input " + (isFormSubmitted && name === "" ? "is-invalid " : "")} name="name" value={name} onChange={(e) => {setName(e.target.value)}} placeholder={t("Enter your Name")}
                                    required />
                                <div className="invalid-feedback">{t("Please Enter Name")}</div>
                            </div>
                            <div className="form-group">
                                <label className="mt-2  ">{t("Email")} *</label>
                                <input autoComplete="off" type="text" className={"form-control saw-input " + (isFormSubmitted && (isValidEmail(email) || !email) ? " is-invalid" : "")} name="email" value={email} onChange={(e) => {setEmail(e.target.value)}} placeholder={t("Enter your Email")}
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                                    required />
                                <div className="invalid-feedback">{t("Please Enter Valid Email")}</div>
                            </div> */}
              <div className="form-group col-12">
                <div className="input-group">
                  <textarea autoComplete="off" rows={5} className={'form-control saw-input' + (isFormSubmitted && comments === '' ? ' is-invalid' : '')} name="comments" value={comments} onChange={(e) => setComments(e.target.value)} placeholder={t('Your Message')} title="" />
                  <div className="invalid-feedback">{t('Please Enter Comments')}</div>
                </div>
              </div>
              {/* <div className="form-group">
                                <label className="mt-2">{t("Comments")} *</label>
                                <div className="input-group" id="show_hide_password">
                                    <textarea autoComplete="off"
                                        rows={5}
                                        className={"form-control saw-input" + (isFormSubmitted && comments === "" ? " is-invalid" : "")} name="comments" value={comments} onChange={e => setComments(e.target.value)} placeholder={t("Enter comments if any")}
                                        required
                                    />
                                    <div className="invalid-feedback">{t("Please Enter Comments")}</div>
                                </div>
                            </div> */}
              <div className="row justify-content-center">
                <button className="btn btn-grad" disabled={loadingBTN} onClick={submit}>
                  {loadingBTN ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : t('Submit')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(ContactUs);
